import { render, staticRenderFns } from "./AdminVideoCard.vue?vue&type=template&id=388eac6f&"
import script from "./AdminVideoCard.vue?vue&type=script&lang=js&"
export * from "./AdminVideoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports